import { getCompatEnv } from '@fabric-app/compat/capabilities/environment';

const getSocketOrigin = () => {
  return getCompatEnv().isFabricDev ? getCompatEnv().DASHBOARD_URL : new URL(getCompatEnv().WOODY_API_URL || "").origin;
};
const SOCKET_INSTACE_OPTIONS = {
  reconnectionDelayMax: 1e4,
  autoConnect: false,
  withCredentials: true,
  transports: [
    "polling"
  ]
};
const roomConfigs = {
  resources: {
    path: "/resources/{resourceId}"
  },
  timeline: {
    path: "/timeline"
  },
  signup: {
    path: "/signup"
  },
  exports: {
    path: "/exports/{exportId}"
  }
};

export { SOCKET_INSTACE_OPTIONS, getSocketOrigin, roomConfigs };
//# sourceMappingURL=config.js.map
